import React from 'react';
import StaticLayoutInner from '@/layouts/StaticLayoutInner';

export function LoadingScreen() {
	return (
		<StaticLayoutInner centerContent>
			<div className="self-center w-full">
				<svg className="animate-rotation w-12 h-12 text-[#0D4E58] m-auto"
				     width="24"
				     height="25"
				     viewBox="0 0 24 25"
				     fill="none"
				     xmlns="http://www.w3.org/2000/svg">
					<path d="M22 12.5C22 18.0228 17.5228 22.5 12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5"
					      stroke="#EAE6E0"
					      strokeWidth="4"
					      strokeLinecap="round" />
					<path d="M12 2.5C11.4467 2.5 10.9039 2.54494 10.375 2.63136"
					      stroke="#EAE6E0"
					      strokeWidth="4"
					      strokeLinecap="round" />
					<path d="M2 12.5C2 18.0228 6.47715 22.5 12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5"
					      stroke="currentColor"
					      strokeWidth="4"
					      strokeLinecap="round" />
				</svg>
			</div>
		</StaticLayoutInner>
	);
}
